import { controllerSchedulesEn } from "./controllerSchedules";

const en = {
  ...controllerSchedulesEn,
  /** Global */
  WELCOME: "Welcome",
  HI: "Hi",
  LANG: "Language",
  BACK_TO_HOME_PAGE: "Back to Home Page",
  INSTALL_APP: "Install App",
  NUM_IS_GREATER_ERROR: "Enter a number smaller than",
  NUM_IS_LESS_ERROR: "Enter a number greater than",
  DETAILS: "Details",
  CLEAR: "Reset",
  SAVE: "Save",
  UPLOAD: "Upload",
  NEW: "New",
  CANCEL: "Cancel",
  EDIT: "Edit",
  DELETE: "Delete",
  LOGOUT: "Log out",
  ACCEPT: "Confirm",
  ERROR: "Error",
  CLOSE: "Close",
  GOOD_AFTERNOON: "Good afternoon",
  GOOD_EVENING: "Good evening",
  GOOD_NIGHT: "Good night",
  GOOD_MORNING: "Good morning",
  PATH_EXISTS: "Identifier already exists - please choose a different one",
  CREATED: "Created Date",
  NO_DATA: "No data to display",
  QTY: "Quantity",
  TYPE: "Type",
  PRICE: "Price",
  TEMPLATES: "Design",
  SEND: "Send",
  REFRES: "Refresh",
  SEARCH: "Search",
  SAVED_SUCCESS: "Saved successfully",
  LINK_COPY_SUCCESS: "Link copied successfully",
  UNLIMITED: "Unlimited",
  ADMIN_AREA: "Admin Area",
  FREE: "Free",
  REMOVE: "Remove",
  CONTINUE: "Continue",
  DELETE_INFO: "After deletion, the information cannot be restored",
  DOWNLOAD: "Download",
  PAY_ATTENTION: "Pay attention",
  SHOW: "Show",
  DATE: "Date",
  SUNDAY: "Sunday",
  MONDAY: "Monday",
  TUESDAY: "Tuesday",
  WEDNESDAY: "Wednesday",
  THURSDAY: "Thursday",
  FRIDAY: "Friday",
  SATURDAY: "Saturday",
  HELLO: "Hello",
  LAST_ACTIVE: "Last activity",
  COLOR: "Color",
  EMPLOYEE: "Employee",
  DEPARTMENT_MANAGER: "Department Manager",
  BIZ_MANAGER: "Business Manager",
  INVENTORY: "Inventory Manager",
  ROLE: "Permissions",
  LINK_COPY_SUCCESSFULLY: "Link copied successfully",
  TABLE: "Table",
  CARDS: "Cards",
  STATUS: "Status",
  ADD: "Add",
  ALL: "All",
  FULL: "Full",
  EMPTY: "Empty",
  GLOBAL: "General",
  EMP_AND_DATES: "Scheduling & Time",
  PAYMENTS: "Payments",
  PROVIDERS_AND_PAYMENTS: "Suppliers & Payments",
  EMPLOYEE_NAME: "Assigned employee",
  CREATE_GUID: "Create Identifier",
  CHECK_CONNECTED: "Check connection",
  NETWORK_CONNECTION_GUIDE_TITLE: "Connect the sensor to the network",
  NETWORK_CONNECTION_GUIDE_1: "Open the Wi-Fi networks list on your phone or computer",
  NETWORK_CONNECTION_GUIDE_2: "Find a network named 'MyBee'",
  NETWORK_CONNECTION_GUIDE_3: "Tap Connect and enter the password shown on the back of the sensor",
  NETWORK_CONNECTION_GUIDE_4: "A login page will open",
  NETWORK_CONNECTION_GUIDE_4_1: "If the page doesn’t open, click here",
  NETWORK_CONNECTION_GUIDE_5: "On the page, enter your Wi-Fi login details (network name and password)",
  NETWORK_CONNECTION_GUIDE_6: "If the sensor connected, you will see: 'Device connected to the internet.'",
  NETWORK_CONNECTION_GUIDE_7: "Tap Check connection at the bottom of this page",
  SET_ALL_ASTERISK_ERROR: "Please fill in all fields marked with an asterisk (*)",
  TEST: "Test",
  WS_IS_CONNECTED: "Connected to server",
  WS_IS_DISCONNECTED: "Disconnected from server",
  NUMBER_MUST_BE_BETWEEN: "The number must be between",
  NUMBER_MUST_BE_GREATER_THAN: "The number must be greater than",
  NUMBER_MUST_BE_LESS_THAN: "The number must be less than",
  SETTINGS_AND_ADMIN: "Settings & Administration",
  NO_PLUGIN: "You are not authorized to open a call - for more information contact customer service",
  HAS_TWO_FACTOR: "Enable two-factor authentication",
  TWO_FACTOR_NEED_EMAIL_ERROR: "Please add an email to enable two-factor authentication",
  TWO_FACTOR_CODE: "Two-factor authentication",
  CODE: "Enter the code you received",
  TWO_FACTOR_SEND_EMAIL: "A verification code was sent to your email.",
  TWO_FACTOR_INPUT: "Enter the code to complete the process.",
  TWO_FACTOR_CODE_REQUIRED: "Verification code is required",
  SEND_AGAIN_TIMER: "I didn’t receive a code",
  SEND_AGAIN: "Send code again",
  SEND_CODE_SUCCESS: "Code sent successfully",
  SELECTED_LANG: "Language selection",
  LANGUAGE: "Language",
  HE: "Hebrew",
  EN: "English",
  AR: "Arabic",
  RU: "Russian",
  CHANGE_LANG_SUCCESS: "Language changed successfully",
  CHANGE_LANG_ERROR: "We couldn't change the language. Please try again",
  ICON: "Icon",
  TITLE: "Title",
  URL: "Website URL",

  // new
  NOTIFY_MAIL: "Notification email",
  QR_NOT_FROM_SYS_ERROR: "QR not recognized. Please scan a system QR only",
  HISTORY_AND_REPORTS: "History & Reports",
  INSTANT: "Instant",
  MORE: "More",
  BLACK_LIST_DIALOG: "Blocked user",
  DESIGN: "Design",
  IS_ACTIVE: "Active",
  NICK_NAME: "Nickname",
  DESC_TITLE: "Description title",
  SUB_TITLE: "Subtitle",
  WITHOUT: "Without",
  MORNING: "Good morning",
  NOON: "Good afternoon",
  AFTER_NOON: "Good afternoon",
  EVENING: "Good evening",
  NIGHT: "Good night",
  DAYS: "Days",
  HOURS: "Hours",
  MINUTES: "Minutes",
  SECONDS: "Seconds",
  PORTAL: "Portal",
  COPY: "Duplicate",
  PERMISSION_SUCCESS: "Permission granted",
  PERMISSION_ERROR: "Permission denied",
  USER_PERMISSION_ERROR: "User not approved",
  DONT_ASK_AGAIN: "Don't ask again",
  REMIND_NEXT_TIME: "Remind me next time",
  DAILY: "Daily",
  WEEKLY: "Weekly",
  MONTHLY: "Monthly",
  YEARLY: "Yearly",
  WEEKS: "Weeks",
  YEARS: "Years",
  MONTHS: "Months",
  EVERY: "Every",
  IN_DAYS: "In days",
  IN_DAY: "On day",
  IN_TIME: "At",
  IN_MONTHS: "In months",
  IN: "In",
  DOUBLE_CLICK_FOR_OPEN: "Double-click to open",
  ENTER: "Enter",
  FOR_CONFIRM_DELETION: "to confirm deletion",
  DATA_DOES_NOT_MATCH: "Value does not match",
  REFRESH: "Refresh",
  DESCRIPTION: "Description",
  PLATFORM: "Platform",
  IS_PRODUCTION: "Production",
  API: "API",
  BO: "Admin Panel",
  MC: "Controller",
  WEB: "Website",
  SERVER: "Server",
  YES: "Yes",
  NO: "No",
  ACTIVE: "Active",
  CLOSED: "Closed",
  HISTORY: "History",
  UPDATE_SUCCESSFULLY: "Updated successfully",
  NONE: "None",
  FLAG: "Flag",
  STATUS_LED_POWER_CHANGE_IMMEDIATE: "*Changes apply immediately - no need to save",
  NEW_BIZ: "New Business",
  SELECTED_BIZ: "Selected Business",
  MENU: "Menu",
  TIME: "Time",
  SETTINGS: "Settings",
  CLOSE_MENU: "Close menu",
  UNITS: "Units",
  DISPLAY_TYPE: "Display type",
  SHOW_FIELD: "Fields to display",
  USER_PALETTE_MODE: "Display mode",
  MASSAGE: "Message",
  EXPORT_EXCEL: "Export to Excel",
  EXPORT_PDF: "Download PDF",
  EXPORT: "Export",
  EXPORT_TABLE: "Export table",
  INIT: "System refresh",
  SYSTEM: "System",
  CREATED_BY: "Created by",
  MEDIA_SIZE_BIG_ERROR: "The selected file exceeds the allowed limit",
  MEDIA_NOT_ALLOWED_ERROR: "Unsupported file type",
  MEDIA: "Media",

  /** Validations */
  REQUIRED: "Required field",
  URL_ERROR: "Please enter a valid URL, e.g. https://www.google.co.il",
  CEL_ISRAELI_ERROR: "Please enter a valid mobile number",
  EMAIL_ERROR: "Please enter a valid email",
  ONLY_NUMBER_ERROR: "Numbers only",
  PATH_ERROR: "Please enter English letters and numbers (min 3, max 20 characters)",
  PASSWORD_ERROR:
    "At least 8 characters, including 1 uppercase letter, 1 lowercase letter, 1 digit, and 1 special character",

  /** Plans */
  PLANS_MANAGEMENT: "Plans Manager",
  servicesCall: "Service Calls",
  contactUs: "Mail",
  schedule: "Schedule",
  PLANS: "Plans",
  maxClients: "Clients limit",
  maxEmployees: "Employees limit",
  maxItems: "Items limit",
  maxWebAppMessage: "Messages limit",
  EVERY_MONTH: "per month",
  SELECT_PLAN: "Select plan",
  ONLY_SYS_ADMIN: "Visible to system admins only",
  SYS_NAME: "System name",
  PLAN_DETAILS: "Plan",
  WS_IS_NOT_CONNECTED: "The system is not connected to the server. Please try again in a few seconds",

  /** Dates Reports */
  DATES: "Date Picker",
  START_DATE: "Start date",
  END_DATE: "End date",
  CREATE_REPORT: "Create report",
  TODAY: "Today",
  THIS_WEEK: "This week",
  THIS_MONTH: "This month",
  THIS_YEAR: "This year",
  ALL_EMPLOYEES: "All employees",
  PMT_TYPE: "Payment status",
  ALL_PMT: "All payment types",
  ALL_STATUS: "All statuses",
  //new
  MAX_METER_READ: "Last reading",
  DAILY_AVERAGE: "Daily average",

  /** Login */
  LOGIN: "Login",
  CONNECT: "Connect",
  USER_NAME: "Username",
  PASSWORD: "Password",
  HAS_SIGNIN: "Don't have an account yet?",
  SIGNIN_NOW: "Create account",
  KEEP_LIGIN: "Remember me on this device",
  REMEMBER_ME: "Remember me",
  LOGIN_ERROR: "Login error",
  LOGIN_SUCCESS: "Logged in successfully",
  BIZ_SUCCESS: "Business opened successfully",

  /** Recommend */
  RECOMMEND: "Recommendations",
  RECOMMEND_DESC: "Recommendation description",

  /** Templates */
  BASIC: "Basic",
  CLASSIC: "Classic",
  WAVES: "Waves",
  BUBBLE: "Bubbles",
  TEMP_TYPE_ID: "Choose design",
  CLASSIC_1: "Classic 1",
  DESIGN_1: "Design 1",

  /** Signup */
  SIGNUP: "Let’s get started",
  SIGNUP_NFO: "Quick signup and you're in",
  USER_DETAILS: "User details",
  BIZ_DETAILS: "Business details",
  BIZ_TEL: "Business phone",
  BIZ_EMAIL: "Business email",
  BIZ_DESC: "A bit about the business",
  VALID_PASSWORD: "Confirm password",
  EMAIL_FOR_RESET_PASSWORD: "Email for password reset",
  HAS_LOGIN: "Already have an account?",

  //** Analytics */
  ANALYTICS: "Analytics",

  /** Private Area */
  PRIVATE_AREA: "Private area",

  /** plans */
  MAX_CLIENTS: "Clients limit",
  MAX_EMPLOYEES: "Employees limit",
  MAX_ITEMS: "Items limit",
  MAX_WEBAPPMESSAGE: "Messages limit",
  YOUR_PLAN: "Your plan",
  DELETE_PLAN: "Are you sure you want to delete this package?",

  /** plugins */
  PLUGINS: "Ons",
  PLUGINS_MANAGER: "Ons Manager",
  MAX_QTY: "Max quantity",
  PROPERTIES: "Properties",
  SELECT_PLUGIN: "Add add-on",
  REMOVE_PLUGIN: "Remove add-on",
  REMOVE_PLUGIN_ASK: "Are you sure you want to remove",
  REMOVE_PLUGIN_INFO:
    "Your data will be kept, but you won’t have access to it or to the add-on’s features",
  REMOVE_AFTER_SAVE: "Note: the add-on will be removed only after clicking Continue",
  DELETE_PLUGIN: "Are you sure you want to delete this add-on?",
  PLUGIN_DETAILS: "Add-on",

  /** desktop */
  DASHBOARD: "Dashboard",
  STATUS_SERVICES_CALL: "Service calls status",
  SUM: "Total",
  NOT_WORK_DT: "No work date",
  NO_INVOICE_NUMBER: "No invoice",
  TOTAL_EXPENSES_PROVIDERS: "Supplier expenses",
  TOTAL_REVENUE: "Total revenue",
  DEVICE_ACTIVE: "Active",
  DEVICE_LOW_EFFECTIVE: "Low efficiency",
  DEVICE_NOT_ACTIVE: "Off",
  DEVICE_FAULT: "Faulty",
  // new
  REVENUE: "Revenue",
  CHLORINE_METERS_WEEKLY: "Chlorine meter",
  GAS_METERS_WEEKLY: "Gas meter",
  ELECTRICITY_METERS_WEEKLY: "Electricity meter",
  WATER_METERS_WEEKLY: "Water meter",
  AVERAGE_WEEKLY: "Weekly average",
  HAS_READ_TODAY: "Daily reading exists",
  NOT_READ_TODAY: "No daily reading",
  READ_TODAY: "Daily reading",
  LAST_MONTH: "Previous month",
  LAST_YEAR: "Previous year",
  COMPARISON_BY: "Compare by",
  BY_EMPLOYEE: "Breakdown by employee",
  NOT_RANGE: "Out of hours",
  RANGE: "Within hours",
  REAL_DATA: "Real data",
  FAKE_DATA: "Mock data",
  SHORTCUT: "Shortcuts",
  ACTION: "Action",
  MONTHLY_UTILITY: "Monthly average efficiency",
  LAST_MONTHLY_UTILITY: "Previous month efficiency",
  DEVICES: "Devices",
  DEVICE: "Device",

  /** Business */
  COLOR1: "Color 1",
  COLOR2: "Color 2",
  COLOR3: "Color 3",
  LOGO: "Logo",
  IMAGE_HEADER: "Landing pages cover",
  LAT_AND_LON: "Latitude & Longitude",
  DESC_BIZ_TITLE: "Business description title",
  DESC_BIZ: "Business description",
  IS_EXAMPLE: "Demo business",
  IS_SYSTEM: "System business",
  HAS_SERVICE_MEDIA: "Access media in service calls",
  HOTEL_CODE: "Hotel code",

  //new
  BIZ_UPDATED_SUCCESS: "Business updated successfully",
  BIZ_TYPE: "Business type",
  SERVICE_PROVIDER: "Service provider",
  MAINTENANCE_DEPARTMENT: "Maintenance department",
  HOTEL: "Hotel",
  FACTORY: "Factory",

  /** Departments */
  DEPARTMENTS: "Departments",
  DEPARTMENT: "Department",
  MANAGER: "Manager",
  PLUGINS_LIST: "Add-ons list",
  ADD_PLUGINS: "Add add-on",
  SELECT_PLUGINS: "Select add-ons",
  LINKED_PLUGINS: "Linked add-ons",
  // new
  IS_DEPARTMENT_BLOCKED: "Department blocked",
  DEPARTMENT_NAME: "Department name",
  DEPARTMENT_CLIENT_GUID: "Department identifier",
  REPORTING_DEPARTMENTS: "Reporting departments",
  REPORTING_DEPARTMENT: "Reporting department",
  NEW_REPORTING_DEPARTMENT: "New reporting department",
  DEPARTMENTS_QTY: "Departments count",
  MCS: "Controllers",
  MC_LIST: "Controllers list",
  SELECT_MC: "Select controller",
  NO_SELECTED_MC_INFO: "This department can view all business controllers",

  /** Employee */
  EMPLOYEES: "Employees",
  EMPLOYEE_IMG: "Employee photo",
  CARD: "Card",
  EMPLOYEE_DETAILS: "Employee details",
  FN: "First name",
  LN: "Last name",
  BIZ_ROLE: "Role",
  TEL: "Phone",
  EMAIL: "Email",
  OF: "of",
  CARD_QTY: "Cards count",
  EMPLOYEES_PATH: "Employee identifier",
  BUSINESS_CARD: "Business card",
  WEB_APP_PAGE: "Landing page",
  LOGIN_EMP: "Employee login",
  LOGIN_EMP_LINK: "Employee login link",
  OPEN_LINK: "Open link",
  COPY_LINK: "Copy link",
  USER_NAME_EXISTS: "Username already exists - please choose a different one",
  DELETE_EMPLOYEES: "Are you sure you want to delete this employee?",
  IS_BO_ALLOWED: "Admin panel access",
  HAS_WEB: "Employee page",
  LOGIN_EMP_LINK_INFO: "The link is personal and cannot be transferred (each employee has a different link)",
  //new
  EXTRA_BUSINESSES: "Additional businesses",
  SECONDARY_EMAIL: "Additional email",

  /** items */
  SKU: "SKU",
  DESC: "Description",
  IS_WEB_SALE: "Displayed on website",
  NAME: "Name",
  WARRANTY_TIME: "Warranty period (days)",
  DELETE_ITEM: "Are you sure you want to delete this item?",
  ITEMS_QTY: "Items count",
  ITEM_DETAILS: "Item details",
  ITEM: "Item",
  SELECT_ITEMS: "Select items",

  /** Clients */
  CLIENTS: "Clients",
  GET_CLIENTS_ERROR: "Error importing clients",
  CLIENT_GUID: "Client identifier",
  COMPANY: "Company name",
  CONTACT_NAME: "Contact name",
  CLIENT_DETAILS: "Client details",
  GUID_EXISTS: "Identifier already exists, please choose another one",
  CLIENT_QTY: "Clients count",
  ITEMS_LIST: "Items list",
  ADD_ITEM: "Add item",
  ITEMS: "Items",
  NEW_CLIENT: "New client",
  GUID: "Identifier",
  SELECT_ITEM: "Select item",
  DELETE_CLIENT: "Are you sure you want to delete this client?",
  ALL_CLIENTS: "All clients",
  IS_BLOCKED: "Blocked client",
  HAS_CHECK_LIST: "Task list",

  /** Services call */
  SERVICE_CALL_ACTIVE: "Open",
  SERVICE_CALL_APPROVAL: "Closed",
  SERVICE_CALL_HISTORY: "History",
  SERVICES_CALL: "Call/Order",
  CALL_ID: "Call #",
  OPEN: "Open",
  SELECT_EMPLOYEE: "Assigned employee",
  PMT_TYPE_ID: "Billing status",
  PAY: "Billable",
  NOT_PAY: "Not billable",
  SERVICE: "Service",
  WAITING: "Waiting",
  NOTES: "Notes",
  CLIENT_CALL_ID: "Client call #",
  ALL_CALLS: "All calls",
  JOB_DONE_DESC: "Work performed",
  SELECT_EMP: "Select employee",
  DESC_PROBLEM: "Issue description",
  CREATE_SERVICES: "Open new call",
  IMPORT_CALL: "Import calls",
  NEW_CALL: "New call",
  RESET: "Reset",
  DELETE_SERVICES_CALL: "Are you sure you want to delete this service call?",
  WORK_DT: "Work start",
  DODAY: "Today",
  CLIENT_NAME: "Contact",
  ORDER_NUM: "Order number",
  INVOICE_NUM: "Invoice number",
  QUOTATION_NUM: "Quotation number",
  CREATE_QR: "Create QR",
  S_C: "S.C",
  DISPLAY_SETTINGS: "Display settings",
  PROVIDERS: "Suppliers",
  CONTENT_WITH_ITEMS: "Issue description",
  SEND_SEVICES_SUMMARY: "Send visit summary",
  OPEN_SEVICES_SUMMARY: "Open visit summary",
  CLIENT_NO_EMAIL: "Cannot send - this client has no email",
  CHANGE_DATES: "Change dates",
  START: "Start",
  END: "End",
  PROVIDERS_EXPENSES: "Supplier expenses",
  SEND_SUCCESS: "Visit summary sent successfully",
  WORK_END_DT: "Work end",
  WORK_END_DT_ISBEFORE_WORK_DT_ERROR: "End date cannot be before start date",
  SUBMIT_AND_SEND_SUMMARY: "Save and send visit summary",
  APPROVAL: "Approved",
  SELECT_DEPARTMENTS: "Select department",
  SELECT_CLIENT: "Select client",
  CREATE_SERVICE_CALL: "Open service call",
  SERVICE_CALLS: "Service calls",
  //new
  ADD_FAULT: "Add fault",
  ADD_FAULTS: "Add faults",
  ADD_ITEMS: "Add items",
  CLOSE_SERVICE: "Close call",
  CHANGE_EMP: "Assign to employee",
  ADD_FLAG_SERVICE: "Add flag",
  REMOVE_FLAG_SERVICE: "Remove flag",
  CHANGE_EMP_SUCCESS: "Employee assigned successfully",
  ELAPSED_TIME: "Elapsed time",
  ADD_HAS_FALG: "Add flag",
  REMOVE_HAS_FALG: "Remove flag",
  ADD_HAS_FALG_SUCCESS: "Flag added to the call",
  REMOVE_HAS_FALG_SUCCESS: "Flag removed from the call",
  WORKS: "Work performed",
  ADD_NEW_WORK: "Add new work",
  NO_WORKS_ADDED: "No work added",
  SUPPLIER_COSTS: "Supplier costs",
  NO_SUPPLIER_COSTS: "No supplier costs added",
  ADD_NEW_SUPPLIER_COST: "Add new supplier cost",
  SUPPLIER_NAME: "Supplier name",
  COST: "Cost",
  ITEM_NAME: "Item name",
  FINANCIAL_SUMMARY: "Financial summary",
  MOVE_TO_BIZ: "Switch business",
  BIZ_NOT_INCLUDE_PLUGIN: "No access to the requested service",
  SELECT_BIZ_TO_MOVE: "Select business to switch",
  LOADING_YOUR_WORKSPACE: "Loading your workspace...",
  TIME_FROM_STARTCALL: "Time since call opened",

  /** Schedule Services Call */
  SCHEDULE_SERVICES_CALL: "Scheduled",
  NOTIFICATION_IN_DAY: "Notification (days)",
  FREQUENCY: "Frequency",
  NEXT_OCCURRENCE: "Next occurrence",
  FREQUENCY_DATA_ERROR: "Please select a frequency",
  EMPLOYEE_ERROR: "Please select an employee",
  SELECT_ITEM_OR_CLIENT_ERROR: "Please select an item or a client",
  FREQUENCY_DAYS_ERROR: "Please select at least one day",
  FREQUENCY_TIME_ERROR: "Please select a time",
  START_DT_ERROR: "Please select a start date",
  FREQUENCY_WEEKLY_INTERVAL_ERROR: "Please select how many weeks between occurrences",
  FREQUENCY_MONTHLY_INTERVAL_ERROR: "Please select how many months between occurrences",
  FREQUENCY_DAY_INTERVAL_ERROR: "Please select which day of the month it occurs",
  FREQUENCY_YEARLY_INTERVAL_ERROR: "Please select how many years between occurrences",

  /** Control And Monitoring */
  CONTROL_AND_MONITORING: "Controllers",
  TEMP1: "Return air",
  TEMP2: "Supply air",
  LOADING_TO_DATA: "Waiting...",
  ACTIVE_DATA: "AC status",
  ON_MC: "On",
  OFF_MC: "Off",
  TEMP_ACTIVE: "Temp",
  TEMP: "Temp",
  DELTA: "Delta",
  MODE_ACTIVE: "Mode",
  TURN_ON_DATE: "Turn on date",
  TURN_OFF_DATE: "Turn off date",
  FAULT: "Fault",
  FAULTS: "Faults",
  CLOGGED_FILTER: "Dirty filter / coil / blower - cleaning required",
  HEAVY_CLOGGED_FILTER: "Severely dirty filter / coil / blower - immediate cleaning required",
  SENSOR_ERROR: "One of the sensors is faulty - please contact customer support",
  LACK_GAS: "It seems there is low refrigerant - open a technician call",
  COMPRESSOR_NOT_STOP: "Compressor doesn't stop - check the AC immediately",
  TURN_ON_DATE_INFO_RELAY: "Turn on the device?",
  TURN_OFF_DATE_INFO_RELAY: "Turn off the device?",
  TEMP_OUT_OF_RANGE: "Temperature out of valid range",
  SENSOR_DISCONNECTED: "Temperature sensor disconnected",
  B22_POWER_OK: "Connected to mains power",
  B22_PARENT_MONITORING: "Power loss and backup battery notifications",
  B22_HISTORY: "Temperature history",
  B22_HISTORY_RANGE: "Choose a valid range of up to 31 days",
  B22_LOAD_FAILED: "Could not load data",
  POWER_SOURCE_BATTERY: "Controller switched to backup battery",
  TURN_ON_DEVICE: "Turn on",
  TURN_OFF_DEVICE: "Turn off",
  ALL_AREAS: "All areas",
  MC_IS_DISCONNECTED: "Controller is not connected to the network",
  DELETE_MC: "Are you sure you want to delete this controller?",
  STATUS_LED_POWER: "Lighting status",
  MIN_SETPOINT: "Min setpoint",
  MAX_SETPOINT: "Max setpoint",
  DEAD_BAND: "Dead band",
  ALL_DEVICE: "All products",
  EFFECTIVE: "Efficient",
  LOW_EFFECTIVE: "Low efficiency",
  TEMP_ALERTS: "Temperature alerts",
  DEVICE_ALERTS: "Device alerts",
  MC_NOT_CONNECTED: "The controller is not connected to the network",
  ACTIVE_TEMP: "Current temp",
  ACTIVE_DHT: "Current humidity",
  SET_POINT_ACTIVE: "Target temp",

  /** Calendar */
  CALENDAR: "Calendar",
  LOCATION: "Location",
  AVAILABILITY: "Availability",
  AVAILABLE: "Available",
  BUSY: "Busy",
  PERSONAL: "Personal",
  VOLUNTEERING: "Volunteering",
  SCHOOL: "School",
  WORK: "Work",
  FAMILY: "Family",
  DELETE_EVENT: "Are you sure you want to delete this event?",

  /** Meter Reading */
  METER_READING: "Meters",
  METER_ID: "Meter number",
  READ_VALUE: "Reading",
  ELECTRICITY: "Electricity",
  WATER: "Water",
  GAS: "Gas",
  METER_READ: "Meter reading",
  DELETE_METER_READ: "Are you sure you want to delete this reading?",
  CREATED_READ: "Reading date",
  METER_LAST_READ: "Last meter reading",
  ERROR_DAY: "Daily reading was performed",
  WATER_QTY: "m³",
  ELECTRICITY_QTY: "kWh",
  GAS_QTY: "m³",
  //new
  IS_NOT_BETWEEN_RANGE: "Outside allowed hours",
  READ_IS_EXCEED: "Exceeds the limit",
  CHLORINE: "Chlorine",
  CHLORINE_QTY: "ml",
  CONSUMPTION: "Actual consumption",
  METER_NOT_FOUND: "Meter not found",
  CREATE_METER_READ: "New meter reading",
  OFF_PEAK_VALUE: "Off-peak",
  MID_PEAK_VALUE: "Mid-peak",
  ON_PEAK_VALUE: "On-peak",
  LAST_READ_VALUE: "Previous reading",

  /** meter */
  METER_NAME: "Name/Location",
  METER_GUID: "Meter number",
  METERS: "Meters",
  THERE_ARE_NO_METERS: "No meters available for reading. Please create a meter before taking a reading",
  SELECT_METER: "Select meter",
  //new
  EXCEEDING_LIMIT: "Alert threshold (%)",
  RECOMMEND_TIME_READ: "Recommended reading time",
  METER: "Meter",
  IS_METER_ACTIVE: "Meter is active",
  FIRST_READ_VALUE: "Initial reading",
  IS_TARIFF: "Multi-tariff meter",

  /** Settings */
  BIZ_SETTINGS: "Business settings",
  BIZ_NAME: "Business name",
  ADDR: "Address",
  SETTINGS_CONTROL_AND_MONITORING: "Controller settings",

  /** contact us */
  CONTACT_US: "Contact us",

  /** Schedule */
  SCHEDULE: "Schedule",

  /** MC Installation */
  ACTIVATE_SIM: "Activate SIM",
  FINISH_INSTALLATION: "Finish installation",

  /** Micro Controllers Manager */
  MICRO_CONTROLLERS_MANAGER: "Controllers",
  MICRO_CONTROLLERS: "Controllers",
  MICRO_CONTROLLER: "Controller",
  MICRO_CONTROLLER_DETAILS: "Controller details",
  FOR_CONFIRM_FACTORY_RESET: "to factory reset",
  ERROR_FACTORY_RESET_NOT_CONNECTED: "Cannot factory reset. The controller is not connected to the network",
  FACTORY_RESET_SUCCESS: "Factory reset completed successfully. The controller is restarting",
  FACTORY_RESET_ERROR: "Factory reset error. Please try again",
  AIR_CONDITIONER: "Air conditioner",
  LIGHTING: "Lighting",
  WATER_PUMP: "Water pump",
  BOILER: "Boiler",
  GENERATOR: "Generator",
  COMPRESSOR: "Compressor",
  ELEVATOR: "Elevator",
  REFRIGERATION: "Cold room",
  RELAY: "Relay",
  HVAC: "HVAC",
  GATE: "Electric gate",
  SOLAR: "Solar system",
  FIRE_SYSTEM: "Fire system",
  IRRIGATION: "Irrigation system",
  MACHINE: "Industrial machine",

  IS_LINKED_MC: "Controller is already flashed",
  MC_NOT_FOUND: "Controller not found",
  CHECK_ACTIVATED: "Controller check",
  MC_HAPPY: "Controller is OK",
  MICRO_CONTROLLER_CREATE: "Create controller",
  DELETE_MICRO_CONTROLLER: "Are you sure you want to delete this controller?",
  ACTIVATED: "Activation",
  MINI_DETAILS: "Basic details",
  CONNECT_TO_WIFI: "Connect to Wi-Fi",
  MC_CONNECTED: "Controller connected to the network",
  MC_DISCONNECTED: "Controller not connected to the network",
  MC_ACTIVATED: "Controller is already in use",
  OUTSIDE_WORKING_HOURS: "Outside working hours",
  OUTSIDE_WORKING_HOURS_MSG: "Oops, it looks like you're trying to turn on the device after working hours",
  OUTSIDE_WORKING_HOURS_MSG_1: "Select how long you want to turn on the device",
  ONE_HOUR: "One hour",
  TWO_HOURS: "Two hours",
  THREE_HOURS: "Three hours",
  FOUR_HOURS: "Four hours",
  SOFTWARE_TYPE: "Software",
  SIM_ID: "SIM ID (ICCID)",
  LINK_TO_BUSINESS: "Linked to business",
  GUID_COPY_SUCCESSFULLY: "Identifier copied successfully",
  SIM_ID_COPY_SUCCESSFULLY: "SIM ID copied successfully",
  FACTORY_RESET: "Factory reset",
  DELETE_TEMP_DATA: "Delete temperature data",
  CONNECTED_STATUS: "Connection",
  ERROR_MC_NOT_CONNECTED: "Cannot perform this action. The controller is not connected to the network",
  DEVICE_TYPE: "Device type",
  ERROR_CHANGE_BIZ_MC_NOT_CONNECTED: "Cannot change business. The controller is not connected to the network",
  ERROR_CHANGE_DEAD_BAND_MC_NOT_CONNECTED: "Cannot change dead band. The controller is not connected to the network",
  ERROR_CHANGE_WEEKLY_TIMES_MC_NOT_CONNECTED: "Cannot change schedule. The controller is not connected to the network",
  ERROR_MIN_SETPOINT_MUST_BE_LESS_THAN_MAX_SETPOINT: "Max temperature must be higher than min temperature",
  MIN_TEMP_TOO_CLOSE_TO_MAX: "The minimum temperature must be at least 5° lower than the maximum temperature.",
  ST_LOCATION: "Location",
  TRANSIT: "In transit",
  STORAGE: "Storage",
  IN_TECHNICIAN: "With technician",
  INSTALLATION: "Installation in progress",
  LAB: "Lab",
  REPAIR: "Under repair",
  CUSTOMER: "At customer",
  TURNOFF_LED_SUCCESS: "Lighting turned off successfully",
  TURNON_LED_SUCCESS: "Lighting turned on successfully",
  HAS_TEMP_SENSOR: "Has temperature sensor",
  OK: "OK",
  FAULTY: "Faulty",
  DECOMMISSIONING: "To be decommissioned",
  DECOMMISSIONED: "Decommissioned",
  HEALTH_STATUS: "Health status",
  MIN_TEMP: "Min temp",
  MAX_TEMP: "Max temp",
  FAULT_DELAY_TIME: "Alert delay",
  MC_GUID_NOT_FOUND: "Invalid controller ID",
  FLASH: "Flash",
  MODEM_IMEI: "Modem IMEI",
  ADD_MC_AND_CLICK_SEARCH: "Connect the controller to the computer and click \"Search\"",
  STICKER: "Sticker",
  SEARCH_BY_DEVICE: "Search by device",
  CREATE_MCS: "Add controllers",
  CREATE: "Add",
  FLASH_MC: "Flash controller",
  ROOM_ID: "Room ID",
  MANUAL: "Manual",
  PRINT_MC_NAME: "Installation label",

  B1_0: "B1.0",
  B1_1: "B1.1",
  B1_3: "B1.3",
  B1_4: "B1.4",
  B1_5: "B1.5",
  B2_0: "B2.0",
  B2_2: "B2.2",
  MC_MODEL: "Model",

  /** Areas */
  AREAS: "Areas",
  AREA: "Area",
  DELETE_AREA: "Are you sure you want to delete this area?",
  NO_AREA: "Not assigned to an area",

  /** Webapp Message */
  WEBAPP_MESSAGE: "Mail",
  OPEN_MESSAGE: "Open message",
  FULL_NAME: "Contact",
  IS_READ: "Message status",
  MESSAGE: "Message",
  READ: "Read",
  NOT_READ: "Unread",
  SELECTED_EMP: "Select employee",

  /** support */
  SUPPORT: "Support",
  SUPPORT_SUBJECT: "Request subject",
  SUPPORT_MESSAGE: "Request message",
  TECHNICAL_ISSUE_HELP: "Technical issue – assistance required",
  USAGE_QUESTION: "Technical question about system usage",
  BUG_REPORT: "Bug report or unexpected behavior",
  SUPPORT_SUCCESS: "Request opened successfully",
  SUPPORT_NUMBER: "Request #",
  SAVE_SUPPORT_NUMBER: "Recommended to save the request number for tracking until it is resolved",
  SUPPORT_RECEIVED_1: "Your request has been received.",
  SUPPORT_RECEIVED_2: "A representative will contact you shortly.",

  /** business manager */
  BUSINESS_MANAGER: "Business",
  BUSINESS: "Businesses",
  EXAMPLE_BUSINESS: "Demo businesses",
  NAVIGATE_BUSINESS: "Switch business",
  PATH: "Identifier",

  /** Ac Commands*/
  BRAND: "Brand",
  MODEL: "Model",
  VERSION: "Version",
  YEAR_MANUFACTURE: "Year of manufacture",
  REGION: "Region",
  ON: "On",
  OFF: "Off",
  VENT: "Vent",
  COOL: "Cool",
  HEAT: "Heat",
  DRY: "Dry",
  AUTO: "Auto",
  ECO: "Eco",
  SLEEP: "Sleep",
  TURBO: "Turbo",
  DEGREES: "Degrees",
  PROTOCOL: "Protocol",
  BITS: "Bits",
  MODES: "Modes",
  POWER: "Power",
  POWER_COMMANDS: "Power & modes",
  TEMPS_COMMANDS: "Temperature",
  AC_COMMANDS_MANAGER: "AC Commands",
  FAN_SPEED: "Fan speed",
  LOW: "Low",
  MEDIUM: "Medium",
  HIGH: "High",
  COMMANDS: "Commands",
  SELECT_COMMAND: "Assign commands (usually by AC brand and model)",
  TEST_COMMAND_SUCCESS: "Test sent to the controller - if received, the AC should turn on",
  COMMAND_NOE_FOUND_ERROR: "Please select an AC brand",
  WEEKLY_TIMES: "Weekly schedule",
  DIFFERENCE: "Difference",

  /** Check List */
  CHECK_LIST: "Tasks",
  NO_CHECK_LIST: "No tasks",
  CHECK_LIST_CLOSED: "Closed tasks",
  CHECK_LIST_OPENED: "Open tasks",
  TASKS: "Tasks",
  NO_RECORDS: "No projects",
  RECORDS: "Projects",
  CLOSED_DATE: "Close date",
  DELETE_CHECK_LIST_ITEM: "Are you sure you want to delete this task?",

  /** reports */
  REPORTS: "Reports",
  INVOICE_STATUS: "Invoice number status",
  METER_READ_REPORT: "Meter readings",
  TEMP_REPORT: "Temperature report",
  SELECT_MC_ERROR: "Please select a controller",
  TEMP_IN_PLACE: "On-site temperature",
  YEARLY_SERVICE_CALL_REPORT: "Yearly service calls report",
  INCOME: "Income",
  EXPENSES: "Expenses",
  PROFIT: "Profit",
  LOSS: "Loss",
  PROFIT_OR_LOSS: "Profit/Loss",

  /** mini site */
  MINI_SITE: "Site",
  MINI_SITES: "Sites",
  DELETE_MINI_SITE: "Are you sure you want to delete this site?",
  WITHOUT_CLIENT: "No client",
  SEND_SITE: "Send link to open a service call",
  LINK_SENDING: "Link sent successfully",
  LINK_SENDING_ERROR: "Error sending link",
  SELECT_CONTACT: "Select from contacts",
  CONTACTS_SELECTED_SUCCESS: "Contact selected successfully",
  HAS_SERVICE_SUMMARY_MINI_SITE: "Site visit list",
  HIDE_CLIENT_DETAILS: "Hide client details",
  HAS_APP: "Has app",
  HIDE_CLIENT_CALL_ID: "Hide client call number",

  /** colors name */
  LIGHT_PINK: "Light pink",
  LIGHT_YELLOW: "Light yellow",
  PALE_GREEN: "Pale green",
  LIGHT_BLUE: "Light blue",
  OFF_WHITE: "Off-white",
  LIGHT_LAVENDER: "Light lavender",
  SOFT_RED: "Soft red",
  SOFT_CYAN: "Soft cyan",
  SOFT_GOLD: "Soft gold",
  SOFT_MINT: "Soft mint",
  SOFT_LILAC: "Soft lilac",

  /** Request */
  PERMISSION: "Permissions",
  REQUEST_NOTIFICATION: "Notifications",
  AUTHORIZE_ACCESS: "Allow",
  PERMISSION_MSG1: "Our system needs the following permissions to provide you with the best experience.",
  PERMISSION_MSG2: "Please allow access to the following notifications:",

  /** create Google Calendar */
  GOOGLE_CALENDAR_SERVICE_TITLE: "Service call number",
  GOOGLE_CALENDAR_SERVICE_DESCRIPTION: "For more details, click the following link",
  CREATE_GOOGLE_CALENDAR: "Add to Google Calendar",

  /** Logs */
  LOGS: "Logs",
  LOGS_DELETE_SUCCESS: "Logs deleted successfully",
  LOGS_DELETE_ERROR: "Error deleting logs. Please try again",

  /** Profile */
  PROFILE: "Profile",

  /** Mc Request */
  SCAN_SITE: "Site survey",
  SELECT_BIZ: "Select business",
  CREATE_BIZ: "Create business",
  CREATE_AREA: "Create area",
  WAITING_FLASH: "Waiting to flash",
  IN_PROGRESS: "Flashing in progress",
  COMPLETED: "Controller ready",

  /** Notification */
  NOTIFICATION: "Notifications",
  NOTIFICATION_IS_ACTIVE: "Notifications enabled",
  NOTIFICATION_NOT_ACTIVE_INFO: "No notifications will be sent for this controller. Recommended to enable notifications as soon as possible.",
  READ_BY: "Read by",
  DELETE_NOTIFICATION: "Are you sure you want to delete this notification?",

  /* system */
  ADMIN: "General Admin",
  SUB_ADMIN: "Deputy General Admin",
  INFRASTRUCTURE_SCANNER: "Infrastructure Scanner",
  SERVICE_TECHNICIAN: "Technical Support",
  SALES_REPRESENTATIVE: "Sales Representative",
  TECHNICIAN: "Technician",
};

export default en;
